var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAccountinline = function SvgAccountinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3597_34479)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 .833A9.167 9.167 0 0 0 .833 10a9.129 9.129 0 0 0 2.094 5.832A9.148 9.148 0 0 0 10 19.167a9.148 9.148 0 0 0 7.111-3.382A9.13 9.13 0 0 0 19.167 10 9.166 9.166 0 0 0 10 .833Zm6.324 13.2a7.5 7.5 0 1 0-12.648 0c.256-.203.578-.43.971-.654 1.158-.662 2.91-1.296 5.353-1.296 2.443 0 4.195.634 5.353 1.296.393.225.716.451.971.654Zm-11.6 1.297A7.476 7.476 0 0 0 10 17.5a7.476 7.476 0 0 0 5.277-2.17 6.056 6.056 0 0 0-.75-.504c-.918-.524-2.386-1.076-4.527-1.076-2.14 0-3.608.552-4.525 1.076-.31.177-.559.352-.751.504ZM10 4.482a3.333 3.333 0 1 0 0 6.667 3.333 3.333 0 0 0 0-6.667ZM8.822 6.637a1.667 1.667 0 1 1 2.357 2.357 1.667 1.667 0 0 1-2.357-2.357Z",
    fill: "#252525"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3597_34479"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgAccountinline;